import { ModelData } from './model-data';
import { ProjectSections } from '@bimdata/definitions/const';

const mainSections = new Map<string, number>(Object.values<string>(ProjectSections).map((v, i) => [v, i + 1]));

export const CompareSections = (a: Section, b: Section) => {
  return CompareSectionNames(a.name, b.name);
};

export const CompareSectionNames = (a: string | null, b: string | null) => {
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }

  const ai = mainSections.get(a);
  const bi = mainSections.get(b);
  if (!ai && !bi) {
    return a.localeCompare(b);
  }
  if (!ai) {
    return 1;
  }
  if (!bi) {
    return -1;
  }
  return ai - bi;
};

export type Section = {
  name: string | null;
  elements: number;
  geometries: number;
  models: ModelData[];
  ready: boolean;
}